<ngx-spinner type="ball-atom"></ngx-spinner>
@if (message) {
  <div class="component-container">
    <div class="component-header">
      <div class="component-header-title">
        <h2>@if (message.title) { {{ message.title }} } @else { <em>(Untitled)</em> }</h2>
        @if (message.companyId) {
          <p class="component-header-subtitle company-link">
            <a [routerLink]="['/companies/edit', message.companyId]" class="company-link-btn" title="Edit company">
              <mat-icon>open_in_new</mat-icon>
            </a>
            {{ message.companyName }}
          </p>
        }
        <p class="component-header-subtitle-secondary">from {{ message.sentByUserFullName }}</p>
      </div>
      <div class="button-group">
        @if (message.hasAttachment) {
          <button mat-raised-button color="primary" (click)="onDownloadAttachment()">
            <mat-icon>download</mat-icon>
            {{ message.fileName || 'Download Attachment' }}
          </button>
        }
        <button mat-raised-button color="primary" (click)="onBack()">
          <mat-icon>arrow_back</mat-icon>
          Back to Messages
        </button>
      </div>
    </div>

    <div class="conversation-thread">
      <!-- Original Message -->
      <div class="message-card original-message">
        <div class="message-header">
          <div class="message-sender">
            <div class="avatar">
              <mat-icon>person</mat-icon>
            </div>
            <div class="sender-info">
              <span class="sender-name">{{ message.sentByUserFullName }}</span>
              <span class="message-meta">to {{ getRecipientNames() }}</span>
            </div>
          </div>
          <span class="message-date">{{ message.createdDate | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="message-body" [innerHTML]="message.messageText | linkify"></div>
      </div>

      <!-- Replies -->
      @for (answer of visibleAnswers; track answer.id) {
        <div class="message-card reply-message" [style.border-left-color]="'color-mix(in srgb, var(--mat-sys-primary) ' + (100 - $index * 15) + '%, transparent)'">
          <div class="message-header">
            <div class="message-sender">
              <div class="avatar">
                <mat-icon>person</mat-icon>
              </div>
              <div class="sender-info">
                <span class="sender-name">{{ answer.sentByUserFullName }}</span>
                <span class="message-meta">to {{ getAnswerRecipientNames(answer) }}</span>
              </div>
            </div>
            <span class="message-date">{{ answer.createdDate | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="message-body" [innerHTML]="answer.answerText | linkify"></div>
        </div>
      }

      @if (hasHiddenAnswers) {
        <div class="show-full-thread">
          <button mat-raised-button color="primary" (click)="onShowFullConversation()">
            <mat-icon>unfold_more</mat-icon>
            Show full conversation
          </button>
        </div>
      }

      <!-- Reply Box -->
      <div class="reply-section">
        @if (!isReplying) {
          <button mat-raised-button color="primary" (click)="onToggleReply()">
            <mat-icon>reply</mat-icon>
            Reply
          </button>
        } @else {
          <div class="message-card reply-compose">
            <form [formGroup]="replyForm">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Write your reply...</mat-label>
                <textarea matInput formControlName="answerText" rows="4"></textarea>
                @if (replyForm.get('answerText')?.hasError('required') && replyForm.get('answerText')?.touched) {
                  <mat-error>Reply cannot be empty</mat-error>
                }
              </mat-form-field>
            </form>
            <div class="reply-actions">
              <button mat-flat-button class="nrg-error-flat-button" (click)="onToggleReply()">
                <mat-icon>clear</mat-icon>
                Cancel
              </button>
              <button mat-flat-button color="primary" (click)="onSendReply()" [disabled]="replyForm.invalid">
                <mat-icon>send</mat-icon>
                Send
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
